<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <rkm-area
            no-margin-top
            title="BPA"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.instrumentosRegistro"
                        label="Instrumento de registro padrão"
                        text-field="nome"
                        v-model="model.bpaIntrumentoRegistroPadrao"
                        value-field="codigo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    created() {
        this.repositories = {
            configuracao: this.getConectaSusRepository('administracao.configuracao')
        }
    },
    data: () => ({
        form: null,
        model: null,
        cotaFormatoTrabalhoAtual: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.configuracao.edit()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.cotaFormatoTrabalhoAtual = this.model.cotaFormatoTrabalho
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {

                        this.setLoading()

                        this.repositories.configuracao.update(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>